/* eslint-disable no-extra-parens */
/* eslint-disable react/display-name */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { asWidget } from './asWidget.jsx';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { reduxConnect } from '../../../common/index';
// import { HurricaneWidget } from '../../hurricane/hurricaneWidget';
import { HurricaneWidgetLazy } from '../../hurricane/hurricaneWidgetLazy';
import { lifeRoutes } from '../../../common/translation/translate.js';

const mapStoreStateToProps = storeState => {
    const { units } = storeState || {};
    const { pressureUnit, windUnit } = units;
    const appState = storeState?.appState?.appState || {};
    const { user, routePath, isHurricaneSectionEnabled } = appState;

    const { CityName: cityName, TerritoryAbbr: stateAbbreviation, SlugName: activeLocationSlugname } = user?.ActiveLocation?.Locality || {};

    return {
        routePath,
        cityName,
        stateAbbreviation,
        activeLocationSlugname,
        isHurricaneSectionEnabled,
        pressureUnit,
        windUnit
    };
};

const mapDispatchToProps = {};

@reduxConnect(mapStoreStateToProps, mapDispatchToProps)
@asWidget
export class LinkWidget extends Component
{
    static displayName = 'LinkWidget';

    static propTypes = {
        backgroundImage: PropTypes.string.isRequired,
        icon: PropTypes.string,
        headerText: PropTypes.string,
        linkUrl: PropTypes.string,
        widgetType: PropTypes.string.isRequired,
        activeLocationSlugname: PropTypes.string,
        cityName: PropTypes.string,
        stateAbbreviation: PropTypes.string,
        isHurricaneSectionEnabled: PropTypes.bool,
        pageId: PropTypes.string,
        pressureUnit: PropTypes.number,
        windUnit: PropTypes.number
    };

    constructor(props)
    {
        super(props);

        this.state= {

        };
    }

    render()
    {
        const { backgroundImage, icon, linkUrl, isHurricaneSectionEnabled } = this.props;

        /**
         * TechDebt: We need to look into AppState issue to avoid dealing with stuff like this in many places
         * This should take of instances where the appState sometimes returns undefined for values between re-renders
         */
        if (typeof isHurricaneSectionEnabled !== 'boolean') {
            return null;
        }

        if (isHurricaneSectionEnabled && linkUrl?.toLowerCase() === 'alerts/hurricane/') {
            return  <HurricaneWidgetLazy />;
        }

        const styles = {
            container: {
                backgroundImage: `url(${backgroundImage})`
            }
        };

        const hasWidgetIcon = icon && !icon.isNullOrWhiteSpace();

        // eslint-disable-next-line no-extra-parens
        let widgetIcon = (
            <img alt='Life style index' className='widget--LifestyleIndex__icon' src={icon}></img>
        );

        if (linkUrl?.startsWith(`/${lifeRoutes.lifeOutdoorSports}`)) {
            widgetIcon = (
                <img alt='Disney Weather Check Logo' className='widget--Life__outdoorSportsWidget' src={icon}></img>
            );
        }

        return (
            <LazyLoadComponent threshold={100} useIntersectionObserver={true}>
                <div className='widget__body static-height'>
                    <div className='widget--Photo__image' style={styles.container}>
                        { hasWidgetIcon && widgetIcon }
                    </div>
                </div>
            </LazyLoadComponent>
        );
    }
}
